import { useAuth, type SubscriptionTier } from '../context/AuthContext'
import { isMultiFacilityViewer } from '../lib/auth/facilityScope'

export function useTier(): SubscriptionTier {
  const { viewerContext } = useAuth()
  return viewerContext?.tier ?? 'standalone'
}

/**
 * Returns true if the user has multi-facility scope (consultant, enterprise corporate/regional).
 * Enterprise facility-level users return false (they see standalone-like experience).
 * Fail closed: enterprise unknown/none scope is not multi (#1897 — empty ≠ corporate).
 */
export function useIsMultiFacility(): boolean {
  const { viewerContext } = useAuth()
  return isMultiFacilityViewer(viewerContext)
}
